export default {
  wrapper: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '50px',
    minHeight: '50px',
  },
  button: {
    width: '100%',
    height: '100%',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'background-color .2s ease',
    '&:hover': {
      backgroundColor: 'hsla(0, 0%, 0%, 0.1)',
    },
  },
}



// WEBPACK FOOTER //
// ./src/Components/LoadMore/styles.js